module.exports = __webpack_public_path__ + "static/media/math_arena_case_study_screen_2.579f9a0a.png";